import React from "react";
import loadImage from "blueimp-load-image";
import generatePassword from "generate-password";
import Select, { components } from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import queryString from "qs";
import _ from "lodash";

import {
  RetailerTypesOptions,
  RetailerPartToken,
  OfferRedemptionTypeOptions,
  TerritoryOptions,
  CurrencyOptions,
  RetailerVoucherOptions,
} from "../../Constants/retailer";
import AddBranchModal from "../../components/AddBranchModal";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";

import "./index.css";
import {
  createRetailerLeadAdmin,
  removeTaskerFromAuth,
  sendResetPassword,
  updateRetailerAdminLead,
  resetPassword,
} from "../../api/UserApi";
import EditItem from "./components/EditItem";

import LiveIcon from "../../assets/media/icons/live.svg";
import InactiveIcon from "../../assets/media/icons/inactive.svg";

const UKIcon = require("../../assets/media/uk.jpg");
const USAIcon = require("../../assets/media/usa.jpg");
const IrelandIcon = require("../../assets/media/ireland.jpg");
const CanadaIcon = require("../../assets/media/canada.jpg");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
};

const RetailerFullToken = [
  {
    value: 0,
    label: "N/A",
  },
  ..._.times(50, (number) => ({
    value: number + 1,
    label: `${number + 1}`,
  })),
];

const MinimumSpendArray = [
  {
    value: 0,
    label: "N/A",
  },
  ..._.times(10, (number) => ({
    value: 5 * (number + 1),
    label: `${5 * (number + 1)}`,
  })),
];

const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option) => (
        <div
          className="territory-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          <img src={TerritoryIcon[option.value]} alt="type" />
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="territory-selected-value">
        <img src={TerritoryIcon[data.value]} alt="type" />
        {data.label}
      </div>
    </components.SingleValue>
  );
};

const TABS = ["Lead Information", "Retailer Admin", "Stores"];
class SuperRetailer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      retailer: null,
      retailerName: "",
      retailerID: "",
      retailerLeadAdminName: "",
      retailerLeadAdminEmail: "",
      redeemed: {
        threshold: 1,
        online: true,
        inStore: true,
        fullTokens: RetailerFullToken[3],
        partTokens: RetailerPartToken[0],
        tokenPercentage: null,
      },
      gift: {
        threshold: "",
        online: true,
        inStore: true,
        fullTokens: RetailerFullToken[0],
        partTokens: RetailerPartToken[0],
        tokenPercentage: null,
      },
      retailerType: RetailerTypesOptions[0],
      offerRedemptionType: OfferRedemptionTypeOptions[0],
      ecopayRetailer: false,
      ecopassRetailer: false,
      retailerAdminEditable: true,
      currentTab: TABS[0],
      loading: true,
      selectedBranch: -1,
      territory: {
        value: TerritoryOptions[0],
        label: TerritoryOptions[0],
      },
      hexCode: "#fafafa",
      minimumSpend: MinimumSpendArray[0],
    };
  }
  componentDidMount() {
    console.log(123);
    // const { retailerId } = queryString.parse(
    //   this.props.location.search.slice(1)
    // );
    const urlParams = new URLSearchParams(this.props.location.search);
    const retailerId = urlParams.get("retailerId");
    const voucherType = urlParams.get("voucherType");
    if (
      !retailerId ||
      !this.props.location.state ||
      this.props.location.state.role !== 0
    ) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getAllRetailers((res) => {
        const keys = Object.keys(res);
        const wgRetailers = keys.map((key) => ({
          ...res[key],
          id: key,
        }));
        Firebase.getAllNCRetailers((res) => {
          const keys = Object.keys(res);
          const ncRetailers = keys.map((key) => ({
            ...res[key],
            id: key,
          }));
          const retailers = [...wgRetailers, ...ncRetailers];

          this.setState({ retailers });

          const retailer = retailers.find((item) => item.id === retailerId);
          if (!retailer) {
            return;
          }
          console.log("retailer", retailer);
          Firebase.getRetailerAdmin(retailer.adminId, (retailerAdmin) => {
            this.setState(
              {
                retailer,
                retailerName: retailer.retailerName || "",
                retailerID: retailer.retailerID || "",
                retailerType:
                  RetailerTypesOptions.find(
                    (item) => item.value === retailer.retailerType
                  ) || RetailerTypesOptions[0],
                redeemed: retailer.redeemed
                  ? {
                      ...retailer.redeemed,
                      fullTokens:
                        RetailerFullToken.find(
                          (item) => item.value === retailer.redeemed.fullTokens
                        ) || RetailerFullToken[0],
                      partTokens:
                        RetailerPartToken.find(
                          (item) => item.value === retailer.redeemed.partTokens
                        ) || RetailerPartToken[0],
                    }
                  : {
                      threshold: 1,
                      online: true,
                      inStore: true,
                      fullTokens: RetailerFullToken[3],
                      partTokens: RetailerPartToken[0],
                      tokenPercentage: null,
                    },
                gift: retailer.gift
                  ? {
                      ...retailer.gift,
                      fullTokens:
                        RetailerFullToken.find(
                          (item) => item.value === retailer.gift.fullTokens
                        ) || RetailerFullToken[0],
                      partTokens:
                        RetailerPartToken.find(
                          (item) => item.value === retailer.gift.partTokens
                        ) || RetailerPartToken[0],
                    }
                  : {
                      threshold: "",
                      online: true,
                      inStore: true,
                      fullTokens: RetailerFullToken[0],
                      partTokens: RetailerPartToken[0],
                      tokenPercentage: null,
                    },
                offerRedemptionType:
                  OfferRedemptionTypeOptions.find(
                    (option) => option.value === retailer.offerRedemptionType
                  ) || OfferRedemptionTypeOptions[0],
                ecopayRetailer: retailer.ecopayRetailer || false,
                ecopassRetailer: retailer.ecopassRetailer || false,
                voucherType: retailer.voucherType
                  ? RetailerVoucherOptions.find(
                      (v) => v.value === retailer.voucherType
                    )
                  : RetailerVoucherOptions[0],
                ...(retailerAdmin
                  ? {
                      retailerLeadAdminName: retailerAdmin.firstName,
                      retailerLeadAdminEmail: retailerAdmin.email,
                      retailerAdminEditable: false,
                    }
                  : {}),
                retailerAdmin: retailerAdmin
                  ? {
                      ...retailerAdmin,
                      id: retailer.adminId,
                    }
                  : null,
                territory: TerritoryOptions.includes(retailer.territory)
                  ? {
                      value: retailer.territory,
                      label: retailer.territory,
                    }
                  : {
                      value: TerritoryOptions[0],
                      label: TerritoryOptions[0],
                    },
                hexCode: retailer.hexCode || "#fafafa",
                minimumSpend: retailer.minimumSpend
                  ? MinimumSpendArray.find(
                      (value) => value.value === retailer.minimumSpend
                    )
                  : MinimumSpendArray[0],
                loading: false,
              },
              this.calcPercentage
            );
          });
        });
      });
    }
  }

  calcPercentage = () => {
    const { redeemed, gift } = this.state;

    this.setState({
      redeemed: {
        ...redeemed,
        tokenPercentage: this.calcPercentageEach(
          redeemed.threshold,
          redeemed.fullTokens.value,
          redeemed.partTokens.value
        ),
      },
      gift: {
        ...gift,
        tokenPercentage: this.calcPercentageEach(
          gift.threshold,
          gift.fullTokens.value,
          gift.partTokens.value
        ),
      },
    });
  };

  calcPercentageEach = (threshold, fullTokens, partTokens) => {
    if (parseInt(threshold, 10)) {
      return Math.round(((fullTokens + partTokens) * 1000) / threshold) / 1000;
    }

    return null;
  };

  onSelectEcoPay = (e) => {
    this.setState({ ecopayRetailer: e.currentTarget.value === "true" });
  };

  onSelectEcoPass = (e) => {
    this.setState({ ecopassRetailer: e.currentTarget.value === "true" });
  };

  handleInputChange = (type, name) => (event) => {
    const parent = this.state[type];
    this.setState(
      {
        [type]: {
          ...parent,
          [name]: event.target.value,
        },
      },
      () => {
        this.calcPercentage();
      }
    );
  };

  selectedFile = (e) => {
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };

  handleChangeChk = (type, name) => (event) => {
    const parent = this.state[type];
    this.setState({
      [type]: {
        ...parent,
        [name]: event.target.checked,
      },
    });
  };

  handleChangeType = (retailerType) => {
    this.setState({ retailerType });
  };

  handleOfferRedemption = (offerRedemptionType) => {
    this.setState({ offerRedemptionType });
  };

  handleTerritoryChange = (territory) => {
    this.setState({ territory });
  };

  handleVoucherTypeChange = (voucherType) => {
    this.setState({ voucherType });
  };

  handleChangeHexCode = (hexValue) => {
    this.setState({ hexCode: hexValue });
  };

  handleMinimumSpendChange = (value) => {
    this.setState({ minimumSpend: value });
  };

  onNameHandler = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleChangeSelectToken = (type, tokenName) => (newValue) => {
    const parent = this.state[type];
    this.setState(
      {
        [type]: {
          ...parent,
          [tokenName]: newValue,
        },
      },
      () => {
        this.calcPercentage();
      }
    );
  };

  onUpdateRetailer = async () => {
    const {
      retailers,
      retailerName,
      retailerID,
      retailerType,
      redeemed,
      gift,
      logo,
      background,
      ecopayLogo,
      ecopayIcon,
      transparentLogo,
      offerRedemptionType,
      ecopayRetailer,
      ecopassRetailer,
      brand,
      territory,
      voucherType,
      hexCode,
      minimumSpend,
    } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    const { retailerId: id } = queryString.parse(
      this.props.location.search.slice(1)
    );

    if (!retailerName) {
      alert("Retailer name is required.");
      return;
    }

    const newRedeemed = {
      ...redeemed,
      partTokens: redeemed.partTokens.value,
      fullTokens: redeemed.fullTokens.value,
    };

    const newGift = {
      ...gift,
      partTokens: gift.partTokens.value,
      fullTokens: gift.fullTokens.value,
    };
    console.log("voucherTpe", voucherType);

    console.log(
      "---",
      // retailers,
      retailerName,
      retailerID,
      retailerType,
      redeemed,
      gift,
      logo,
      background,
      ecopayLogo,
      ecopayIcon,
      transparentLogo,
      offerRedemptionType,
      ecopayRetailer,
      ecopassRetailer,
      brand,
      territory
    );

    if (voucherType.value === "neocurrency") {
      Firebase.updateNCRetailer(
        {
          retailerName,
          retailerID,
          retailerType: retailerType.value,
          redeemed: newRedeemed,
          // gift: newGift,
          // offerRedemptionType: offerRedemptionType.value,
          ecopayRetailer,
          ecopassRetailer,
          territory: territory.value,
          voucherType: voucherType.value,
          hexCode,
          minimumSpend: minimumSpend.value,
        },
        id
      );
    } else {
      Firebase.updateRetailer(
        {
          retailerName,
          retailerID,
          retailerType: retailerType.value,
          redeemed: newRedeemed,
          gift: newGift,
          offerRedemptionType: offerRedemptionType.value,
          ecopayRetailer,
          ecopassRetailer,
          territory: territory.value,
          voucherType: voucherType.value,
          hexCode,
          minimumSpend: minimumSpend.value,
        },
        id
      );
    }
    if (logo) {
      if (voucherType.value === "neocurrency") {
        Firebase.addNCRetailerLogo(retailerName, voucherType.value, logo).then(
          (logoUrl) => {
            Firebase.updateNCRetailer(
              {
                logo: logoUrl,
              },
              id
            );
          }
        );
      } else {
        Firebase.addRetailerLogo(retailerName, retailerType, logo).then(
          (logoUrl) => {
            Firebase.updateRetailer(
              {
                logo: logoUrl,
              },
              id
            );
          }
        );
      }
    }

    if (ecopayLogo) {
      if (voucherType.value === "neocurrency") {
        Firebase.addNCRetailerEcopayLogo(
          retailerName,
          voucherType.value,
          ecopayLogo
        ).then((logoUrl) => {
          Firebase.updateNCRetailer(
            {
              ecopayLogo: logoUrl,
            },
            id
          );
        });
      } else {
        Firebase.addRetailerEcopayLogo(
          retailerName,
          retailerType,
          ecopayLogo
        ).then((logoUrl) => {
          Firebase.updateRetailer(
            {
              ecopayLogo: logoUrl,
            },
            id
          );
        });
      }
    }

    if (background) {
      if (voucherType.value === "neocurrency") {
        Firebase.addNCRetailerBackgroundLogo(
          retailerName,
          voucherType.value,
          background
        ).then((backgroundUrl) => {
          Firebase.updateNCRetailer(
            {
              background: backgroundUrl,
            },
            id
          );
        });
      } else {
        Firebase.addRetailerBackgroundLogo(
          retailerName,
          retailerType,
          background
        ).then((backgroundUrl) => {
          Firebase.updateRetailer(
            {
              background: backgroundUrl,
            },
            id
          );
        });
      }
    }

    if (ecopayIcon) {
      if (voucherType.value === "neocurrency") {
        Firebase.addNCRetailerEcopayIcon(
          retailerName,
          voucherType.value,
          ecopayIcon
        ).then((ecopayIconUrl) => {
          Firebase.updateNCRetailer(
            {
              ecopayIcon: ecopayIconUrl,
            },
            id
          );
        });
      } else {
        Firebase.addRetailerEcopayIcon(
          retailerName,
          retailerType,
          ecopayIcon
        ).then((ecopayIconUrl) => {
          Firebase.updateRetailer(
            {
              ecopayIcon: ecopayIconUrl,
            },
            id
          );
        });
      }
    }

    if (transparentLogo) {
      if (voucherType.value === "neocurrency") {
        Firebase.addNCRetailerTransparentLogo(
          retailerName,
          voucherType.value,
          transparentLogo
        ).then((transparentLogoUrl) => {
          Firebase.updateNCRetailer(
            {
              transparentLogo: transparentLogoUrl,
            },
            id
          );
        });
      } else {
        Firebase.addRetailerTransparentLogo(
          retailerName,
          retailerType,
          transparentLogo
        ).then((transparentLogoUrl) => {
          Firebase.updateRetailer(
            {
              transparentLogo: transparentLogoUrl,
            },
            id
          );
        });
      }
    }

    if (
      retailers[id] &&
      !retailers[id].retailerName &&
      voucherType.value !== "neocurrency"
    ) {
      Firebase.updateRetailer(
        {
          logo: retailers[id],
        },
        id
      );
    }

    let selectedTerritory = this.props.location.state.selectedTerritory;

    this.props.history.push({
      pathname: `/retailer`,
      state: {
        username,
        role,
        brand,
        selectedTerritory,
      },
    });
  };

  onDeleteRetailerLead = async () => {
    const { retailerAdmin, retailer } = this.state;
    const { retailerId } = queryString.parse(
      this.props.location.search.slice(1)
    );
    removeTaskerFromAuth(retailerAdmin.authId)
      .then(() => {
        Firebase.deleteRetailerAdmin(retailer.adminId);
        Firebase.updateRetailer(
          {
            adminId: null,
          },
          retailerId
        );
      })
      .catch(() => {
        alert("Cannot delete retailer lead admin. Please try again later.");
      });
  };

  onInviteRetailerLead = async () => {
    const { retailer, retailerLeadAdminEmail, retailerLeadAdminName } =
      this.state;
    const retailerId = queryString.parse(this.props.location.search.slice(1));

    if (!retailerLeadAdminName || !retailerLeadAdminEmail) {
      alert("First name and email of lead admin user are required fields.");
      return;
    }

    const tempPass = generatePassword.generate({
      length: 10,
      numbers: true,
    });

    createRetailerLeadAdmin(retailerLeadAdminEmail, tempPass)
      .then((response) => {
        const {
          data: { id: uid },
        } = response;

        Firebase.createRetailerAdmin(
          retailerLeadAdminName,
          retailerLeadAdminEmail,
          uid
        )
          .then((adminId) => {
            Firebase.updateRetailer(
              {
                adminId,
                shouldreset: true,
              },
              retailerId
            );

            sendResetPassword(
              retailerLeadAdminEmail,
              retailerLeadAdminName,
              retailer.retailerName,
              tempPass
            );
          })
          .catch(() => {
            removeTaskerFromAuth(uid);
            alert("Cannot create retailer lead admin. Please try again later.");
          });
      })
      .catch(() => {
        alert("Cannot create retailer lead admin. Please try again later.");
      });
  };

  onEditBranchClicked = (index) => () => {
    this.setState({
      selectedBranch: index,
    });
  };

  onAddBranchClicked = () => {
    this.setState({
      selectedBranch: -1,
    });
  };

  onUpdateRetailerLead = () => {
    const {
      retailer,
      retailerAdmin,
      retailerLeadAdminEmail,
      retailerLeadAdminName,
    } = this.state;

    if (!retailerLeadAdminName || !retailerLeadAdminEmail) {
      alert("First name and email of lead admin user are required fields.");
      return;
    }

    updateRetailerAdminLead(retailerAdmin.authId, retailerLeadAdminEmail)
      .then(() => {
        Firebase.updateRetailerAdmin(retailer.adminId, {
          firstName: retailerLeadAdminName,
          email: retailerLeadAdminEmail,
        });
      })
      .catch(() => {
        console.log("Something went wrong!");
      });
  };

  onResetPasswordRetailerLead = (password) => {
    const { retailerAdmin } = this.state;
    resetPassword(retailerAdmin.authId, password).catch(() => {
      console.log("Something went wrong!");
    });
  };

  onDeleteRetailer = () => {
    const { brand } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    let selectedTerritory = this.props.location.state.selectedTerritory;
    const { retailerId } = queryString.parse(
      this.props.location.search.slice(1)
    );
    Firebase.deleteRetailerToken(retailerId);
    this.props.history.push({
      pathname: `/retailer`,
      state: {
        username,
        role,
        brand,
        selectedTerritory,
      },
    });
  };

  addOrUpdateBranch = (branch) => {
    const { retailer, selectedBranch } = this.state;
    const { retailerId } = queryString.parse(
      this.props.location.search.slice(1)
    );

    if (selectedBranch > -1) {
      const newBranches = [...(retailer.branches || [])];
      if (newBranches[selectedBranch]) {
        newBranches[selectedBranch] = {
          ...newBranches[selectedBranch],
          ...branch,
        };
        Firebase.updateRetailer(
          {
            branches: newBranches,
          },
          retailerId
        );
      }
    } else {
      const newBranches = [...(retailer.branches || []), branch];
      Firebase.updateRetailer(
        {
          branches: newBranches,
        },
        retailerId
      );
    }
  };

  onDeleteBranch = () => {
    const { retailer, selectedBranch } = this.state;
    const newBranches = [...(retailer.branches || [])];
    const { retailerId } = queryString.parse(
      this.props.location.search.slice(1)
    );

    if (selectedBranch > -1 && newBranches[selectedBranch]) {
      newBranches.splice(selectedBranch, 1);
      Firebase.updateRetailer(
        {
          branches: newBranches,
        },
        retailerId
      );
    }
  };

  toggleActiveBranch = (index) => () => {
    const { retailer } = this.state;
    const newBranches = [...(retailer.branches || [])];
    const { retailerId } = queryString.parse(
      this.props.location.search.slice(1)
    );

    if (newBranches[index]) {
      newBranches[index].isActive = !newBranches[index].isActive;
      Firebase.updateRetailer(
        {
          branches: newBranches,
        },
        retailerId
      );
    }
  };

  onCancel = () => {
    console.log("location###", this.props.location);
    const { brand } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    let selectedTerritory = this.props.location.state.selectedTerritory;
    this.props.history.push({
      pathname: `/retailer`,
      state: {
        username,
        role,
        brand,
        selectedTerritory,
      },
    });
  };

  render() {
    const {
      retailer,
      brand,
      retailerName,
      retailerID,
      redeemed: {
        online,
        inStore,
        threshold,
        fullTokens,
        partTokens,
        tokenPercentage,
      },
      gift,
      retailerType,
      offerRedemptionType,
      retailers,
      loading,
      retailerLeadAdminName,
      retailerLeadAdminEmail,
      currentTab,
      retailerAdmin,
      selectedBranch,
      territory,
      voucherType,
      minimumSpend,
      hexCode,
    } = this.state;
    const { retailerId: id } = queryString.parse(
      this.props.location.search.slice(1)
    );

    if (!this.props.location.state) {
      return null;
    }

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header username={username} role={role} brand={brand} />
        <main id="main-container">
          <div className="content retailer-details-container">
            {loading && (
              <div className="loading-container">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="role-button-container">
                  {TABS.map((obj) => (
                    <button
                      key={obj}
                      className={`role-button btn ${
                        obj === this.state.currentTab && "active"
                      }`}
                      onClick={() =>
                        this.setState({
                          currentTab: obj,
                        })
                      }
                    >
                      {obj}
                    </button>
                  ))}
                </div>
                {currentTab === TABS[0] && (
                  <div className="retailer-details">
                    <div className="retailer-left-container">
                      <p className="section-title">Retailer Name</p>
                      <input
                        className="form-control form-control-lg form-control-alt name-input"
                        name="retailerName"
                        placeholder="Input retailer name here..."
                        onChange={this.onNameHandler}
                        value={retailerName}
                      />
                      <p className="section-title">Territory</p>
                      <div className="retailer-type-container">
                        <Select
                          value={territory}
                          onChange={this.handleTerritoryChange}
                          options={TerritoryOptions.map((item) => ({
                            value: item,
                            label: item,
                          }))}
                          isSearchable={false}
                          components={{
                            MenuList,
                            SingleValue,
                          }}
                        />
                      </div>
                      <p className="section-title">Voucher connection</p>
                      <div className="retailer-type-container">
                        <Select
                          value={voucherType}
                          onChange={this.handleVoucherTypeChange}
                          options={RetailerVoucherOptions}
                        />
                      </div>
                      <div className="section-title custom-margin">
                        EcoPay Retailer?&nbsp;&nbsp;&nbsp;&nbsp;
                        <div className="yes-no-toggle">
                          <label
                            htmlFor="yes"
                            style={{
                              color: "green",
                            }}
                          >
                            Yes
                          </label>
                          <input
                            type="radio"
                            id="ecopayRetailer"
                            value={true}
                            checked={this.state.ecopayRetailer}
                            onChange={this.onSelectEcoPay}
                          />
                        </div>
                        <div className="yes-no-toggle">
                          <label
                            htmlFor="no"
                            style={{
                              color: "red",
                              marginLeft: 10,
                            }}
                          >
                            No
                          </label>
                          <input
                            type="radio"
                            id="ecopayRetailer"
                            value={false}
                            checked={!this.state.ecopayRetailer}
                            onChange={this.onSelectEcoPay}
                          />
                        </div>
                      </div>
                      <div className="section-title">
                        EcoPass Retailer?&nbsp;&nbsp;&nbsp;&nbsp;
                        <div className="yes-no-toggle">
                          <label
                            htmlFor="yes"
                            style={{
                              color: "green",
                            }}
                          >
                            Yes
                          </label>
                          <input
                            type="radio"
                            id="ecopassRetailer"
                            value={true}
                            checked={this.state.ecopassRetailer}
                            onChange={this.onSelectEcoPass}
                          />
                        </div>
                        <div className="yes-no-toggle">
                          <label
                            htmlFor="no"
                            style={{
                              color: "red",
                              marginLeft: 10,
                            }}
                          >
                            No
                          </label>
                          <input
                            type="radio"
                            id="ecopayRetailer"
                            value={false}
                            checked={!this.state.ecopassRetailer}
                            onChange={this.onSelectEcoPass}
                          />
                        </div>
                      </div>
                      <p className="section-title">Retailer ID</p>
                      <input
                        className="form-control form-control-lg form-control-alt name-input"
                        name="retailerID"
                        placeholder="Input retailer ID here..."
                        onChange={this.onNameHandler}
                        value={retailerID}
                        type="text"
                      />
                      <p className="section-title">Retailer type</p>
                      <div className="retailer-type-container">
                        <Select
                          placeholder="Retailer type"
                          value={retailerType}
                          onChange={this.handleChangeType}
                          options={RetailerTypesOptions}
                          isSearchable={true}
                        />
                      </div>
                      <p className="section-title custom-margin">
                        Retailer redemption selection
                      </p>
                      <div className="retailer-type-container">
                        <Select
                          placeholder="Offer redemption selection"
                          isSearchable={false}
                          value={offerRedemptionType}
                          onChange={this.handleOfferRedemption}
                          options={OfferRedemptionTypeOptions}
                        />
                      </div>
                      <p className="section-title custom-margin">
                        Form of redemption
                      </p>
                      <div className="row_item">
                        <div className="row_item margin-h20">
                          <input
                            type="checkbox"
                            checked={online}
                            onChange={this.handleChangeChk(
                              "redeemed",
                              "online"
                            )}
                          />
                          <p>Online</p>
                        </div>
                        <div className="row_item margin-h20">
                          <input
                            type="checkbox"
                            checked={inStore}
                            onChange={this.handleChangeChk(
                              "redeemed",
                              "inStore"
                            )}
                          />
                          <p>In store</p>
                        </div>
                      </div>
                      <p className="section-title custom-margin">
                        Minimum spend per transaction
                      </p>
                      <div className="row_item" style={{ width: "50%" }}>
                        <p>{CurrencyOptions[territory.value]}</p>
                        <div class="token-select-container">
                          <Select
                            placeholder="Minimum spend per transaction"
                            value={minimumSpend}
                            onChange={this.handleMinimumSpendChange}
                            options={MinimumSpendArray}
                          />
                        </div>
                      </div>
                      <p className="section-title">
                        Shopping tokens per {CurrencyOptions[territory.value]}1
                      </p>
                      <div className="token-redeem-container">
                        {/* <div className="threshold-container">
                          <div className="input-group">
                            <div className="prefix">
                              {CurrencyOptions[territory.value]}
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt threshold"
                              placeholder="Spend threshold"
                              onChange={this.handleInputChange(
                                "redeemed",
                                "threshold"
                              )}
                              value={threshold}
                            />
                          </div>
                        </div> */}
                        <div className="full-token-container">
                          <div className="token-select-container">
                            <Select
                              placeholder="Full tokens (N/A, 1, etc)"
                              value={fullTokens}
                              onChange={this.handleChangeSelectToken(
                                "redeemed",
                                "fullTokens"
                              )}
                              options={RetailerFullToken}
                            />
                          </div>
                          <div className="token-select-container">
                            <Select
                              placeholder="Part tokens (0, 0.25, etc)"
                              value={partTokens}
                              onChange={this.handleChangeSelectToken(
                                "redeemed",
                                "partTokens"
                              )}
                              options={RetailerPartToken}
                            />
                          </div>
                          <div className="form-control form-control-md form-control-alt percentage">
                            {tokenPercentage ? `${tokenPercentage}%` : "N/A"}
                          </div>
                        </div>
                      </div>
                      {/* <p className="section-title">
                        Tokens gifted&nbsp;&nbsp;&nbsp;&nbsp;
                        <span>Gifted on purchases. Leave blank if N/A.</span>
                      </p>
                      <div className="token-redeem-container">
                        <div className="threshold-container">
                          <div className="input-group">
                            <div className="prefix">
                              {CurrencyOptions[territory.value]}
                            </div>
                            <input
                              type="number"
                              className="form-control form-control-md form-control-alt threshold"
                              placeholder="Spend threshold"
                              onChange={this.handleInputChange(
                                "gift",
                                "threshold"
                              )}
                              value={gift.threshold}
                            />
                          </div>
                          <div className="row_item">
                            <input
                              type="checkbox"
                              checked={gift.online}
                              onChange={this.handleChangeChk("gift", "online")}
                            />
                            <p>Online</p>
                          </div>
                          <div className="row_item">
                            <input
                              type="checkbox"
                              checked={gift.inStore}
                              onChange={this.handleChangeChk("gift", "inStore")}
                            />
                            <p>In store</p>
                          </div>
                        </div>
                        <div className="full-token-container">
                          <div className="token-select-container">
                            <Select
                              placeholder="Full tokens (N/A, 1, etc)"
                              value={gift.fullTokens}
                              onChange={this.handleChangeSelectToken(
                                "gift",
                                "fullTokens"
                              )}
                              options={RetailerFullToken}
                            />
                          </div>
                          <div className="token-select-container">
                            <Select
                              placeholder="Part tokens (0, 0.25, etc)"
                              value={gift.partTokens}
                              onChange={this.handleChangeSelectToken(
                                "gift",
                                "partTokens"
                              )}
                              options={RetailerPartToken}
                            />
                          </div>
                          <div className="form-control form-control-md form-control-alt percentage">
                            {gift.tokenPercentage
                              ? `${gift.tokenPercentage}%`
                              : "N/A"}
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div className="retailer-right-container">
                      <EditItem
                        type={{
                          title: "Colour hex code",
                          value: "brand_color",
                          default_value: hexCode || "#fafafa",
                        }}
                        // isDark={dark}
                        onSave={(hexValue) =>
                          this.handleChangeHexCode(hexValue)
                        }
                      />
                      <p className="section-title">Logo</p>
                      <input
                        type="file"
                        id="logo"
                        accept="image/*"
                        onChange={this.selectedFile}
                      />
                      <img src={retailer.logo} height="50" />
                      <p className="section-title">Background</p>
                      <input
                        type="file"
                        id="background"
                        accept="image/*"
                        onChange={this.selectedFile}
                      />
                      <img src={retailer.background} height="50" />
                      <p className="section-title">EcoPay Logo</p>
                      <input
                        type="file"
                        id="ecopayLogo"
                        accept="image/*"
                        onChange={this.selectedFile}
                      />
                      <img src={retailer.ecopayLogo} height="100" />
                      <p className="section-title">EcoPay Icon</p>
                      <input
                        type="file"
                        id="ecopayIcon"
                        accept="image/*"
                        onChange={this.selectedFile}
                      />
                      {retailer.ecopayIcon && (
                        <img src={retailer.ecopayIcon} height="50" />
                      )}
                      <p className="section-title">Transparent Logo</p>
                      <input
                        type="file"
                        id="transparentLogo"
                        accept="image/*"
                        onChange={this.selectedFile}
                      />
                      <img src={retailer.transparentLogo} height="100" />
                      <div className="action-container">
                        <button
                          type="button"
                          className="btn btn-sm btn-light"
                          onClick={this.onCancel}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={this.onDeleteRetailer}
                        >
                          Delete
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={this.onUpdateRetailer}
                          disabled={fullTokens.value ? false : true}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {currentTab === TABS[1] && (
                  <div className="row retailer-admin-section">
                    <div
                      className="col-md-6 col-sm-12"
                      style={{
                        padding: 15,
                        overflow: "auto",
                      }}
                    >
                      <p className="section-title custom-margin">
                        Retailer Lead Admin Name
                      </p>
                      <input
                        className="form-control form-control-lg form-control-alt name-input"
                        name="retailerLeadAdminName"
                        placeholder="First Name"
                        onChange={this.onNameHandler}
                        value={retailerLeadAdminName}
                      />
                      <p className="section-title custom-margin">
                        Retailer Lead Admin Email
                      </p>
                      <input
                        className="form-control form-control-lg form-control-alt name-input"
                        name="retailerLeadAdminEmail"
                        placeholder="Email"
                        onChange={this.onNameHandler}
                        value={retailerLeadAdminEmail}
                      />
                      <div className="action-container">
                        {retailerAdmin && (
                          <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={this.onDeleteRetailerLead}
                          >
                            Delete
                          </button>
                        )}
                        {retailerAdmin && (
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={this.onUpdateRetailerLead}
                          >
                            Save
                          </button>
                        )}
                        {retailerAdmin && (
                          <button
                            type="button"
                            className="btn btn-sm"
                            data-toggle="modal"
                            data-target="#reset_password_super_admin"
                          >
                            Reset password
                          </button>
                        )}
                        {retailerAdmin && (
                          <p className="invited-lead">Invited</p>
                        )}
                        {!retailerAdmin && (
                          <button
                            type="button"
                            className="btn btn-sm btn-invite"
                            onClick={this.onInviteRetailerLead}
                          >
                            Invite
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {currentTab === TABS[2] && (
                  <div>
                    <button
                      className="btn btn-secondary add-retailer-branch-btn"
                      type="button"
                      data-toggle="modal"
                      data-target="#add_branch"
                      onClick={this.onAddBranchClicked}
                    >
                      Add a new branch
                    </button>
                    <div className="branch-list-header">
                      <p>Location</p>
                      <p>Postcode</p>
                      <p>Active</p>
                      <p>Edit</p>
                    </div>
                    <div className="branch-list-items">
                      {(retailer.branches || []).map((branch, index) => (
                        <div className="branch-list-item" key={index}>
                          <p>{branch.townCity}</p>
                          <p>{branch.postcode}</p>
                          <div
                            className="active-container"
                            onClick={this.toggleActiveBranch(index)}
                          >
                            <img
                              src={branch.isActive ? LiveIcon : InactiveIcon}
                              alt="icon"
                            />
                            {branch.isActive ? "LIVE" : "INACTIVE"}
                          </div>
                          <p>
                            <button
                              type="button"
                              className="btn btn-sm btn-secondary"
                              data-toggle="modal"
                              data-target="#add_branch"
                              onClick={this.onEditBranchClicked(index)}
                            >
                              Edit
                            </button>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </main>
        <AddBranchModal
          initialValues={
            selectedBranch > -1
              ? (retailer.branches || [])[this.state.selectedBranch]
              : null
          }
          addBranch={this.addOrUpdateBranch}
          deleteBranch={this.onDeleteBranch}
        />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPasswordRetailerLead}
          initialValues={retailerAdmin}
        />
      </div>
    );
  }
}

export default SuperRetailer;



// WEBPACK FOOTER //
// ./src/screens/super_retailer/index.js